import React, { Component } from 'react'
import EntityList from './../../components/entityList';

class Lights extends Component {
  render() {
    return (
      <EntityList apiRoute='api/lights' title='Remorque - Lumières' editTitle='Lumière' displayColumns={[
        {Description: 'Description', Column: 'Description'},
        {Description: 'Inactif', Column: 'Inactive', sortable: false, format: {type: 'boolean'}}
      ]}/>
    )
  }
}

export default Lights;


/** WEBPACK FOOTER **
 ** ./src/app/routes/trailers/lights.js
 **/